import React from 'react';
import './index.css';
import App from './App';
import { hydrate, render } from "react-dom";
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import store from "./Redux/create"

const root = document.getElementById('root');
if (root.hasChildNodes()) {
  hydrate(<Provider store={store}><App /></Provider>, root)
} else {
  render(<Provider store={store}><App /></Provider>, root)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
